import {
  alpha,
  Box,
  Table as MuiTable,
  styled,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
// import TableFooter from 'components/Mui/TableFooter'
import _ from "lodash";
import { EmptyImage } from "../../assets";

export interface ColumnProps {
  dataIndex: string;
  key: string;
  title: any;
  render?: (cellData: any, row: any) => any;
  textColor?: string;
}

interface TableProps {
  columns: Array<ColumnProps>;
  rowKey?: string;
  dataSource?: any[];
  loading?: boolean;
  headAlign?: any;
  tableAlign?: any;
  onRowClick?: (row: any) => void;
  pagination?: {
    page: number;
    limit: number;
    totalCount: number;
    onChange: (v: number) => void;
    onChangeLimit?: (v: number) => void;
  };
}

export default function Table({
  columns,
  dataSource,
  onRowClick,
  pagination,
  loading,
  headAlign,
  tableAlign,
}: TableProps) {
  return (
    <TableContainer
      sx={{
        borderRadius: "10px",
        border: "1px solid #1212121A",
        borderCollapse: "collapse",
        boxShadow: "0px 5px 15px #22222214",
      }}
    >
      <>
        <MuiTable sx={{ border: "none", borderCollapse: "collapse" }}>
          <TableHead sx={{ backgroundColor: "#F7FAFD" }}>
            <TableRow>
              {columns.map((col, index) => (
                <TableCell align={headAlign} key={index}>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontFamily: "Inter_semibold",
                      opacity: "1",
                    }}
                  >
                    {col.title}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          {dataSource ? (
            <TableBody>
              {dataSource?.map((row, index) => (
                <StyledTableRow
                  canRowClick={!!onRowClick}
                  hover={!!onRowClick}
                  key={index}
                  onClick={() => {
                    return onRowClick && onRowClick(row);
                  }}
                >
                  {columns.map((col, colIndex) => (
                    <TableCell
                      align={tableAlign}
                      sx={{ color: col.textColor }}
                      key={colIndex}
                    >
                      {col?.render ? (
                        <Typography
                          sx={{
                            fontFamily: "Inter_regular",
                            fontSize: "14px",
                          }}
                        >
                          {col.render(row[col.dataIndex], row)}
                        </Typography>
                      ) : (
                        <Typography
                          sx={{
                            fontFamily: "Inter_regular",
                            fontSize: "14px",
                          }}
                        >
                          {_.get(row, col.dataIndex)}
                        </Typography>
                      )}
                    </TableCell>
                  ))}
                </StyledTableRow>
              ))}
            </TableBody>
          ) : (
            <Box
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                paddingLeft: "30%",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img src={EmptyImage} alt="EmptyImage" style={{ paddingTop: "10%" }} />

              <Typography sx={{ padding: "10px" }}>
                No Records Found !..
              </Typography>
            </Box>
          )}
        </MuiTable>

        {/* {pagination && dataSource && (
          <TableFooter
            page={pagination.page}
            limit={pagination.limit}
            totalCount={pagination.totalCount}
            handlePagination={pagination.onChange}
            handlePageLimit={pagination.onChangeLimit}
          />
        )} */}
      </>
    </TableContainer>
  );
}

const StyledTableRow = styled(TableRow)<{ canRowClick: boolean }>(
  ({ theme, canRowClick }) => ({
    ...(canRowClick && {
      cursor: "pointer",
      "&.MuiTableRow-hover:hover": {
        backgroundColor: alpha("#f2f2f2", 0.4),
      },
    }),
  })
);
